export default [
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'text',
      value: (e) => e.currency,
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Minimum',
    },
    cell: {
      type: 'text',
      value: (e) => e.min,
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Maximum',
    },
    cell: {
      type: 'text',
      value: (e) => e.max,
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Edit',
    },
    cell: {
      type: 'slot',
      name: 'edit',
    },
  },
];
